/**
 * Created by prboyapa on 2/8/2016.
 */
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { defineMessages, FormattedMessage, FormattedNumber, FormattedDate, FormattedTime } from 'react-intl';
import classNames from 'classnames';
import moment from 'moment';
import './EstimatedCompletionDate.css';
import InputCalendar from 'components/InputCalendar';
import { useAppState } from 'shared/AppState/app-state';
import * as constants from 'constants/App';
import { Overlay, Popover } from 'react-bootstrap';
import styled from 'styled-components';


const PopoverError = styled(Popover)`
    font-family: "Gotham SSm A", "Gotham SSm B";
    font-style: normal;
    font-size: 14px;
    color: Red;
`;

const EstimatedCompletionDate = ({ 
    estimatedCompletionDate,
    actionType,
    userLocale,
    onDateChangeEvent,
    purchaseOrder,
    isEstimateDateValid,
    onUpdateEstimatedCompletionDate
}) =>
{
    const [appState, dispatch] = useAppState();
        //const locale = window.navigator.userLanguage || window.navigator.language;
        moment.locale(userLocale);

        const inputFormat = "MM/DD/YYYY";
        const mode = "date";
        const [selectedTime, setSelectedTime] = useState(undefined);

        const inputCalendarRef = useRef(null);

    const validateTime = (estimatedDate, from, to) => {
        const hours = moment(estimatedDate).local().hours();
        return (from <= hours && hours < to);
    }

    const onDateChangeHandler = (newDate) => {

        if (newDate !== undefined && moment(newDate).isValid()) {
            onDateChangeEvent(newDate);
            onUpdateEstimatedCompletionDate(true);
            dispatch({ type: constants.UPDATE_IS_ESTIMATED_COMPLETION_DATE_VALID, isEstimateDateValid: true });
        } else {
            onUpdateEstimatedCompletionDate(false);
            onDateChangeEvent(undefined);
            dispatch({ type: constants.UPDATE_IS_ESTIMATED_COMPLETION_DATE_VALID, isEstimateDateValid: false });
        }

    }

    const onTimeChangeHandler = (newTime) => {
        setSelectedTime(newTime);
        updateEstimatedDateTime(newTime, estimatedCompletionDate);
    }

    const updateEstimatedDateTime = (hours, newDate) => {

        if (newDate != undefined && newDate.isValid()) {
            const estimatedDateTime = moment(newDate).local().startOf('day').add(hours, 'hours');
            onDateChangeEvent(estimatedDateTime);
            onUpdateEstimatedCompletionDate(true);
            dispatch({ type: constants.UPDATE_IS_ESTIMATED_COMPLETION_DATE_VALID, isEstimateDateValid: true });

        } else {
            onUpdateEstimatedCompletionDate(false);
            onDateChangeEvent(undefined);
            dispatch({ type: constants.UPDATE_IS_ESTIMATED_COMPLETION_DATE_VALID, isEstimateDateValid: false });
        }

    }

    const isTimeSelectionDisabled = (hours) => {
        const isAfterTime = moment().isAfter(moment().startOf('day').add(hours, 'hours'));
        const isToday = moment().isSame(moment(estimatedCompletionDate), 'day');
        return appState.isPoOverdueEtaValidationEnabled ? actionType == 'VIEW' || (isToday && isAfterTime) : actionType == 'VIEW';
    }

    const messages = defineMessages({
            estimated_completion_description: {
                id: 'estimated_completion_description',
                description: 'Estimated completion for all repairs and services',
                defaultMessage: 'Estimated completion for all repairs and services'
            },
            estimated_completion_morning: {
                id: 'estimated_completion_morning',
                description: 'Morning',
                defaultMessage: 'Morning'
            },
            estimated_completion_afternoon: {
                id: 'estimated_completion_afternoon',
                description: 'Afternoon',
                defaultMessage: 'Afternoon'
            },
            estimated_completion_evening: {
                id: 'estimated_completion_evening',
                description: 'Evening',
                defaultMessage: 'Evening'
            },
            estimated_completion_unavailable: {
                id: 'estimated_completion_unavailable',
                description: 'Unavailable',
                defaultMessage: 'Unavailable'
            },
            estimated_completion_date_invalid: {
                id: 'estimated_completion_date_invalid',
                description: 'Please enter a valid estimated completion date',
                defaultMessage: 'Please enter a valid estimated completion date'
            }
        });

        return (
        <div className={classNames('estimated_completion',
            { 'estimated_completion__edit': actionType == 'ADD' })}>
            <table className="container">
                <tbody>
                    {
                    /*Show or hide editable date control based on user action */                    <tr className="row">

                            <td className="col-md-1">
                            </td>
                            <td colSpan="3" className={classNames('col-md-10',
                                'estimated_completion__box',
                                { "estimated_completion_date_edit__alert": !isEstimateDateValid })}>
                                <div className='row' css={`min-width: 30em;`}>
                                    <div className="col-md-12 estimated_completion__description">
                                        <div className='row'>
                                            <div className="col-md-6 estimated_completion__label">
                                                <FormattedMessage {...messages.estimated_completion_description} />
                                            </div>

                                            <div className={classNames('col-md-6',
                                                { 'estimated_completion__date': actionType == 'VIEW' },
                                                { 'estimated_completion__date_edit': actionType != 'VIEW' })}>
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                        {actionType == 'VIEW' ?


                                                            purchaseOrder.get('estimatedCompletionDate') != undefined &&
                                                                moment(purchaseOrder.get('estimatedCompletionDate')).isValid()
                                                                ? moment(purchaseOrder.get('estimatedCompletionDate')).format(inputFormat)
                                                                : <FormattedMessage {...messages.estimated_completion_unavailable} />
                                                            :
                                                            <div className='row'>
                                                                    <InputCalendar
                                                                        inputProps={{ className: 'estimated_completion_date__date_picker-input' }}
                                                                        onDateChange={onDateChangeHandler}
                                                                        modifiers={{
                                                                            disabled: {
                                                                                before: new Date(moment()),
                                                                            }
                                                                        }}
                                                                        locale={userLocale}
                                                                        initialValue={estimatedCompletionDate !== undefined ? new Date(moment(estimatedCompletionDate)) : undefined}
                                                                        ref={inputCalendarRef}
                                                                    />
                                                                    <Overlay
                                                                        show={!isEstimateDateValid}
                                                                        placement='right'
                                                                        target={inputCalendarRef.current}
                                                                    >
                                                                        <PopoverError>
                                                                            <FormattedMessage {...messages.estimated_completion_date_invalid} />
                                                                        </PopoverError>
                                                                    </Overlay>
                                                                
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='row estimated_completion_time'>
                                                    <div className={classNames({ 'col-md-3': userLocale === 'fr-CA' },
                                                        { 'col-md-4': userLocale === 'en-US' || userLocale === 'es-MX' })}>
                                                        <a className={classNames('btn btn-default',
                                                            { 'btn-default_selected': validateTime(purchaseOrder.get('estimatedCompletionDate'), 0, 12) == true },
                                                            { 'disabled': isTimeSelectionDisabled(8) })}
                                                            role="button"
                                                            onClick={onTimeChangeHandler.bind(this, 8)}>
                                                            <FormattedMessage {...messages.estimated_completion_morning} /></a>
                                                    </div>
                                                    <div className={classNames({ "col-md-4": userLocale === 'es-MX' },
                                                        { "col-md-4 estimated_completion_date__afternoon": userLocale !== 'es-MX' })}
                                                    >
                                                        <a className={classNames('btn btn-default',
                                                            { 'btn-default_selected': validateTime(purchaseOrder.get('estimatedCompletionDate'), 12, 18) == true },
                                                            { 'disabled': isTimeSelectionDisabled(12) }
                                                        )} role="button"
                                                            onClick={onTimeChangeHandler.bind(this, 12)}>
                                                            <FormattedMessage {...messages.estimated_completion_afternoon} /></a>
                                                    </div>
                                                    <div className={classNames({ "col-md-4": userLocale !== 'es-MX' },
                                                        { "col-md-4 estimated_completion_date__afternoon": userLocale === 'es-MX' })}>
                                                        <a className={classNames('btn btn-default',
                                                            { 'btn-default_selected': validateTime(purchaseOrder.get('estimatedCompletionDate'), 18, 24) == true },
                                                            { 'disabled': isTimeSelectionDisabled(18) })} role="button"
                                                            onClick={onTimeChangeHandler.bind(this, 18)}>
                                                            <FormattedMessage {...messages.estimated_completion_evening} /></a>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="col-md-1">
                            </td>
                        </tr>
                    }

                </tbody>
            </table>
        </div>
    )
}



export default EstimatedCompletionDate;